import { GridAddElementEvent } from './GridAddElementEvent';

/**
 * An event that is fired to render the entire grid instead of the default implementation.
 *
 * @memberof FlotiqPlugins.Events
 * @eventName "flotiq.grid::render"
 * @returns {null|string|array|number|boolean|HTMLElement|ReactElement}
 *          Null if rendering should be passed to either Flotiq or other plugins.
 *          Renderable result if plugin wants to place the entire grid.
 */
export class GridRenderEvent extends GridAddElementEvent {}
